import { ComponentProps } from "react";
import ContentWrapper  from "../../layouts/content-wrapper/ContentWrapper.tsx";
import { cn } from "../../../../utils/tailwindMerger.ts";

const defaultLabel = "Right to Work Confirmation Portal";

type HeaderProps = ComponentProps<"header"> & {
    label?: string;
    className?: string;
    scroll?: boolean;
    logo?: string;
};

const Header = ({ label, className, logo, ...props }: HeaderProps) => {
    return (
        <header
            role="navigation"
            className={cn(" bg-neutral py-4 max-sm:py-2 rounded-xl", className)}
            style={{
                boxShadow: "0px 0px 0px 0.2px rgb(0 0 0 / 0.2)",
                ...props.style,
            }}
            {...props}
        >
            <ContentWrapper className="flex md:justify-between items-center max-sm:flex-col ">
                <div className="flex max-sm:justify-center">
                    {/* desktop logo */}
                    <div className="w-[25%] md:flex hidden flex-shrink-0  ">
                        <img
                            className="w-full h-full"
                            src={
                                logo
                                    ? logo
                                    : "https://res.cloudinary.com/do5z8cakb/image/upload/v1729187386/workRight_Logo_shgzl1.png"
                            }
                            alt="Logo"
                            width={359}
                            height={75}
                        />
                    </div>
                    {/* mobile logo */}
                    <div className=" w-[45%] md:hidden flex flex-shrink-0 ">
                        <img
                            className="w-full h-full "
                            src={
                                logo
                                    ? logo
                                    : "https://res.cloudinary.com/do5z8cakb/image/upload/v1729187386/workRight_Logo_shgzl1.png"
                            }
                            alt="Logo"
                            // width={200}
                            // height={75}
                        />
                    </div>
                </div>
                <div className="flex-shrink-0 font-semibold">
                    {label ?? defaultLabel}
                </div>
            </ContentWrapper>
        </header>
    );
};

export default Header;